import React from "react";
import { Row } from "react-bootstrap";
import {
  FaHandshake,
  FaStar,
  FaMoneyBillWave,
} from "react-icons/fa";

const B2bmodal = () => {
  return (
    <section className="vendor-categories-section py-5 bg-white b2b">
      <div className="container py-5">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center mb-5">
            <span className="works-subtitle">B2B Model</span>
            <h2 className="display-5 fw-bold mb-4">
              Product Company Collaboration
            </h2>
            <p className="lead">
              Strong partnerships that enhance service reliability and choice
            </p>
          </div>
        </div>

        {/* Categories */}
        <Row className="g-4">
          {[
            {
              icon: <FaHandshake />,
              title: "Partners",
              subtitle: (
                <ul className="benefit-list text-start">
                  <li>Cement Brands</li>
                  <li>Tiles & Hardware Suppliers</li>
                  <li>Electrical & Plumbing Stores</li>
                  <li>Machinery Providers</li>
                </ul>
              ),
            },
            {
              icon: <FaMoneyBillWave />,
              title: "Income Model",
              subtitle: (
                <ul className="benefit-list text-start">
                  <li>Commission on sales</li>
                  <li>Monthly partnership fees</li>
                  <li>Handling charges for bulk orders</li>
                </ul>
              ),
            },
            {
              icon: <FaStar />,
              title: "Key Benefit",
              subtitle: (
                <ul className="benefit-list text-start">
                  <li>Dual Income Source for sustainability</li>
                </ul>
              ),
            },
          ].map((item, index) => (
            <div key={index} className="col-md-4 col-lg-4">
              <div className="card h-100 text-center hover-card">
                <div className="card-body">
                  <div
                    className={`d-flex align-items-center justify-content-start gap-3`}
                  >
                    <div className="">{item.icon}</div>
                    <h4>{item.title}</h4>
                  </div>
                  <span>{item.subtitle}</span>
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default B2bmodal;
